<section *ngIf="!ready">
  <app-spinner></app-spinner>
</section>

<section *ngIf="ready">
  <div class="years" *ngIf="!year">
    <h1>
      Archive
    </h1>

    <p>Choose a year to see the content we have available.</p>
    <a routerLink="/archive/{{year.year}}" *ngFor="let year of years">{{year.year}}</a>

  </div>

  <div *ngIf="year && !month" class="year">
    <h1>
      <div class="backlinks">
        <a routerLink="/archive/years">Archive</a> &raquo;
      </div>
      <span class="mobile-back">
        <a routerLink="/archive/years" class="btn btn-primary">
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
          Years
        </a>
      </span>
      {{year}}
    </h1>

    <p>Choose a month to see the content we have available.</p>

    <a routerLink="/archive/{{month.month}}" *ngFor="let month of months">
      {{month.month | dateAsUTC | date: 'MMMM'}}
    </a>
  </div>

  <div class="calendar" *ngIf="month && !selectedDay">
    <ng-container *ngIf="!selectedDay">
      <div class="nav-buttons">
        <a routerLink="{{lastMonthUrl}}" class="btn btn-primary" aria-label="Previous Month" *ngIf="isValidMonth(lastMonth)">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          <span class="label">Previous</span>
        </a>
        <div class="spacer"></div>
        <a routerLink="{{nextMonthUrl}}" class="btn btn-primary" aria-label="Next Month"  *ngIf="isValidMonth(nextMonth)">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
          <span class="label">Next</span>
        </a>
      </div>

      <h1>
        <span class="backlinks">
          <a routerLink="/archive/years">Archive</a> &raquo;
          <a routerLink="/archive/{{month | date: 'y'}}">{{year}}</a> &raquo;
        </span>
        <span class="mobile-back">
          <a routerLink="/archive/{{month | date: 'y'}}" class="btn btn-primary">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
            {{year}}
          </a>
        </span>
        {{month | date: 'MMMM'}}
      </h1>
      <br/>

      <div class="no-content" *ngIf="!days || days.length == 0" style="width: 100%;">
        <app-spinner></app-spinner>
      </div>
    </ng-container>

    <div style="width:100%;">
      <p>Choose a day to see the content we have available on TYT.com</p>
    </div>

    <div class="day" *ngFor="let day of days">
      <div class="day-content" *ngIf="day.date" [class.has-episode]="day.episode">
        <span class="date">{{day.date.getDate()}}</span>

        <div class="show-list">
          <ng-container *ngFor="let show of day.shows">
            <div *ngIf="show && show.logo_square" class="avatar" [responsiveBackgroundImage]="show.logo_square"></div>
          </ng-container>
        </div>

        <a routerLink="{{day.url}}"></a>
      </div>
    </div>
  </div>

  <div class="day-overlay" *ngIf="selectedDay">
    <div *ngIf="!selectedDay">
      <app-spinner></app-spinner>
    </div>
    <div *ngIf="selectedDay">

      <div class="nav-buttons">
        <a routerLink="{{selectedDay.lastDayUrl}}" class="btn btn-primary">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          <span class="label">Previous Day</span>
        </a>
        <div class="spacer"></div>
        <a routerLink="{{selectedDay.nextDayUrl}}" class="btn btn-primary">
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
          <span class="label">Next Day</span>
        </a>
      </div>

      <h1>
        <span class="backlinks">
          <a routerLink="/archive/years">Archive</a> &raquo;
          <a routerLink="/archive/{{month | date: 'y'}}">{{month | date: 'y'}}</a> &raquo;
          <a href="javascript:;" routerLink="{{monthUrl}}">{{month | date: 'MMMM'}}</a> &raquo;
        </span>
        <span class="mobile-back">
          <a routerLink="{{monthUrl}}" class="btn btn-primary">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
            {{month | date: 'MMMM'}}
          </a>
        </span>
        {{selectedDay.date | date: 'fullDate'}}
      </h1>

      <div class="episode-list">
        <div *ngIf="selectedDay.episodes.length > 0">
          <a class="mode-link" [class.active]="mode == 'episodes'" href="javascript:;" (click)="mode = 'episodes'">Episodes</a> |
          <a class="mode-link" [class.active]="mode == 'clips'" href="javascript:;" (click)="mode = 'clips'">Clips</a> |
          <a class="mode-link" [class.active]="mode == 'podcasts'" href="javascript:;" (click)="mode = 'podcasts'">Podcasts</a>
        </div>

        <ng-container *ngFor="let production of selectedDay.episodes">
          <tyt-production-view [includeShowName]="true" [production]="production" [mode]="mode"></tyt-production-view>
        </ng-container>

        <div *ngIf="selectedDay.episodes.length == 0">
          <em>No archived content for this day.</em>
        </div>

        <ng-container *ngIf="isDeepArchive">
            <br/><br/>
          <h1>Check the Deep Archive</h1>
          <p>Not all of our content has been imported into our new archive.
            You can check our <a target="_blank" href="{{deepArchiveLink}}">legacy archive</a> for this day
            as well.
          </p>
        </ng-container>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <h1>Past Shows</h1>
  <a routerLink="/shows/aggressive-progressives">Aggressive Progressives</a><br/>
  <a routerLink="/shows/WSlENpFzUYu8kO2s6GEkM">Murder with Friends</a><br/>
  <a routerLink="/shows/6BbVnUNYzeks6Gim6sSQQ6">Pop Trigger</a><br/>
  <a routerLink="/shows/2Nq6VLn81igGM4OsuCGeyk">What the Flick?!</a><br/>
  <a routerLink="/shows/5ydjYgvG1yIC6GQiSw2e2s">The News with Dan Rather</a><br/>
  <a routerLink="/shows/4q2F7FJjoIs0E8Uk0AE6o6">Think Tank</a><br/>

  <br/>

  <h1>Additional Archives from TYTNetwork.com</h1>
  <div class="archived-shows">
    <a target="_blank" href="https://legacy.tyt.com/category/membership/main-show-hour-1/">The Young Turks Hour 1</a><br/>
    <a target="_blank" href="https://legacy.tyt.com/category/membership/main-show-hour-2/">The Young Turks Hour 2</a><br/>
    <a target="_blank" href="https://legacy.tyt.com/category/membership/post-game/">Post Game</a><br/>
    <a target="_blank" href="https://legacy.tyt.com/category/membership/tyt-old-school-on-demand/">TYT Old School</a><br/>
    <a target="_blank" href="https://legacy.tyt.com/category/membership/nerd-alert-on-demand/">Nerd Alert</a><br/>
    <a target="_blank" href="https://legacy.tyt.com/category/membership/what-the-flick-on-demand/">What the Flick?!</a><br/>
    <a target="_blank" href="https://legacy.tyt.com/category/murder-with-friends/">Murder With Friends</a><br/>
    <a target="_blank" href="{{deepArchiveLink}}">Deep Archive</a>
  </div>
</section>
